import React from 'react'

import styled from 'styled-components'

const RemoteWorkEthicsSection = ({
  workStation = 'Not specified.',
  device = 'Not specified.',
  workSchedule = 'Not specified.',
  workShift = 'Not specified.',
  timeTracker = 'Not specified.',
  city,
  country,
}) => {
  return (
    <Wrapper>
      <Header>Remote Fitness Level</Header>

      <SectionHeader>
        <span>SCHEDULE AND TIME ZONE</span>
      </SectionHeader>
      
      <TwoCol>
        {/* Location Time Zone */}
        <div>
          <SubTitle>Location Time Zone</SubTitle>
          <LocationBox>
            <IconPlaceholder>
              <img src={require('../../../assets/image/country.png')} alt="Country" />
            </IconPlaceholder>
            <Text>
              {city && country ? `${city}, ${country}` : "No location provided"}
              <br />
              {city && country ? "GMT+8" : ""}
            </Text>
          </LocationBox>
        </div>

        {/* Working Shift */}
        <div>
          <SubTitle>Working Shift</SubTitle>
          <LocationBox>
            <IconPlaceholder>
              <img src={require('../../../assets/image/working_shift.png')} alt="Country" />
            </IconPlaceholder>
            <Text>
              {city && country ? `${city}, ${country}` : "No location provided"}
              <br />
              {city && country ? "GMT+8" : ""}
            </Text>
          </LocationBox>
        </div>
      </TwoCol>

      <Divider />
      
      <TwoGrid>
        <Label>Work Area</Label>
        <Value>{workStation}</Value>

        <Label>Device</Label>
        <Value>{device}</Value>

        <Label>Schedule</Label>
        <Value>{workSchedule}</Value>

        <Label>Shifts</Label>
        <Value>{workShift}</Value>

        <Label>Time Tracker</Label>
        <Value>{timeTracker}</Value>
      </TwoGrid>
    </Wrapper>
  )
}

// Styled Components
const Wrapper = styled.div`
  background-color: #0e0d3d; /* dark navy */
  color: #ffffff;
  padding: 2rem;
  font-family: 'Poppins', Arial, sans-serif;
  border-radius: 8px;
  border-radius: 0;
`

const Header = styled.h2`
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #ffffff;
`

const SectionHeader = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  margin: 1rem 0 1.5rem 0;
  border-bottom: 2px solid #b84c74;
  display: block; /* full width */
  padding-bottom: 0.25rem;
  color: #fff;
  width: 100%;
`

const TwoCol = styled.div`
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
  align-items: flex-start;
  font-family: 'Segoe UI', Arial, sans-serif;
  gap: 2rem;
`;

const SubTitle = styled.p`
  font-weight: 600;
  font-size: 0.75rem;
  color: #ccc;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  font-family: 'Segoe UI', Arial, sans-serif;
`

const LocationBox = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const IconPlaceholder = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

const Text = styled.p`
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.4;
  font-family: 'Segoe UI', Arial, sans-serif;
`;

const Divider = styled.hr`
  border: 0;
  border-top: 1px solid #444;
  margin: 1.5rem 0;
`

const TwoGrid = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(2, 1fr);
  max-width: 100%;
  gap: .5rem;
  margin-top: 1rem;
`

const Label = styled.p`
  font-weight: 300;
  font-size: 0.75rem;
  color: #aaa;
`

const Value = styled.p`
  font-weight: 500;
  font-size: 0.85rem;
  color: #fff;
`

export default RemoteWorkEthicsSection
